'use memo'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { updateFinderOptIn } from '@sportninja/common/services/player/finderSettingsService'

export const useFinderOptIn = (playerId: string) => {
  const queryClient = useQueryClient()
  return useMutation<void, Error, { isOptedIn: boolean }>({
    mutationFn: ({ isOptedIn }) => updateFinderOptIn(playerId, isOptedIn),
    retry: 0,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.finderSettings.byPlayer(playerId),
      })
      // Opting out removes this player from the Player Finder entirely (and
      // opting in adds them), so a cached spare list would keep showing — or
      // keep hiding — them. Drop those lists.
      queryClient.invalidateQueries({
        queryKey: queryKeys.spareCandidates.all,
      })
    },
  })
}
